/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

export {wrapCreateElement} from '../lib/node/wrap-create-element.js';
export {createElement} from '../lib/node/create-element.js';
